/*!
 * Quiz Recommender — widget embarquable universel (v2)
 * ----------------------------------------------------
 * Intégration sur N'IMPORTE QUEL site avec UNE balise script.
 *
 *   <!-- Mode encart (inline) dans un conteneur -->
 *   <div id="mon-quiz"></div>
 *   <script src="quiz-embed.js"
 *           data-target="#mon-quiz"
 *           data-config="https://votre-cdn.com/config.json"></script>
 *
 *   <!-- Mode bouton flottant + popup (aucun conteneur requis) -->
 *   <script src="quiz-embed.js"
 *           data-mode="modal"
 *           data-config="https://votre-cdn.com/config.json"></script>
 *
 * Sans fichier distant : définir window.QuizEmbedConfig = {...} AVANT le script.
 *
 * Isolation par Shadow DOM (aucun conflit de style avec le site hôte).
 * 100% piloté par la config : questions, pondérations, catalogue.
 *
 * Types de question : "single" | "multi" | "text"
 *   - "text"   : champ libre (ex. personnalisation). N'entre pas dans le score.
 *   - showIf   : { idQuestion: valeur } -> la question n'apparaît que si remplie.
 *
 * Stratégies de matching (champ "match" de chaque question) :
 *   category   : valeurs exclusives + option "autre" (joker) — ex. forme, type
 *   size       : taille avec proximité (ordre défini dans question.order)
 *   color      : la valeur choisie est-elle dans le tableau du produit
 *   has        : idem color (appartenance à un tableau) — ex. type de repas
 *   personalize: "oui" => favorise les produits personnalisables
 *   overlap    : recouvrement multi-choix (ex. activités)
 *   exact      : égalité simple (single)
 *   zone       : égalité avec joker "any"
 *   month      : disponibilité par mois avec proximité
 *   none       : exclue du score (ex. champ texte)
 *
 * Config UI optionnelle : { ui: { maxAlts: 2, altThreshold: 55 } }
 *   -> propose 1 résultat principal + jusqu'à maxAlts alternatives au-dessus du seuil.
 */
(function () {
  "use strict";

  var SCRIPT = document.currentScript;
  function attr(name, def) { return (SCRIPT && SCRIPT.getAttribute(name)) || def; }

  var CONFIG_URL = attr("data-config", null);
  var TARGET_SEL = attr("data-target", null);
  var MODE = attr("data-mode", TARGET_SEL ? "inline" : "modal");
  var POSITION = attr("data-position", null); // "left" | "right"
  var VARIANT = attr("data-variant", null);   // sélectionne une variante de cfg.variants

  function loadConfig() {
    if (window.QuizEmbedConfig) return Promise.resolve(window.QuizEmbedConfig);
    if (window.NamaQuizConfig) return Promise.resolve(window.NamaQuizConfig); // rétro-compat
    if (CONFIG_URL) {
      return fetch(CONFIG_URL, { credentials: "omit" }).then(function (r) {
        if (!r.ok) throw new Error("Config HTTP " + r.status);
        return r.json();
      });
    }
    return Promise.reject(new Error("Aucune config : data-config ou window.QuizEmbedConfig."));
  }

  /* ---------- Moteur de matching ---------- */
  function scoreItem(item, answers, questions, weights) {
    var total = 0, parts = {}, tags = item.tags || {};
    questions.forEach(function (q) {
      if (q.type === "text" || q.match === "none") return;
      var a = answers[q.id], tag = tags[q.id], s = 0;
      var pool = Array.isArray(tag) ? tag : [tag];

      if (q.match === "category") {
        if (a === "autre") {
          var primary = q.opts.map(function (o) { return o.v; }).filter(function (v) { return v !== "autre"; });
          s = primary.indexOf(tag) >= 0 ? 0.2 : 1;
        } else s = (tag === a) ? 1 : 0.2;

      } else if (q.match === "size") {
        var order = q.order || [];
        if (pool.indexOf(a) >= 0) s = 1;
        else {
          var ai = order.indexOf(a);
          var near = pool.some(function (p) { return ai >= 0 && Math.abs(order.indexOf(p) - ai) === 1; });
          s = near ? 0.55 : 0.2;
        }

      } else if (q.match === "color" || q.match === "has") {
        s = pool.indexOf(a) >= 0 ? 1 : 0.3;

      } else if (q.match === "price") {
        var pr = item.price, seg = String(a).split("-"), lo = parseFloat(seg[0]), hi = parseFloat(seg[1]);
        if (pr == null || isNaN(pr)) s = 0.6;
        else if (pr >= lo && (isNaN(hi) || pr <= hi)) s = 1;
        else { var d = pr < lo ? lo - pr : pr - hi; s = d <= 10 ? 0.6 : 0.3; }

      } else if (q.match === "personalize") {
        if (a === "oui") s = (tag === true || tag === "oui") ? 1 : 0.5;
        else s = 1;

      } else if (q.match === "zone") {
        s = (a === "any") ? 0.85 : (tag === a ? 1 : 0.15);

      } else if (q.match === "month") {
        if (a === 0 || a === "0") s = 1;
        else if (pool.indexOf(a) >= 0) s = 1;
        else if (pool.some(function (m) { return Math.abs(m - a) === 1; })) s = 0.5;
        else s = 0.1;

      } else if (q.match === "overlap") {
        var sel = a || [];
        if (!sel.length) s = 0.6;
        else { var hit = sel.filter(function (x) { return pool.indexOf(x) >= 0; }).length; s = 0.15 + 0.85 * (hit / sel.length); }

      } else { // exact
        s = pool.indexOf(a) >= 0 ? 1 : 0.25;
      }

      parts[q.id] = Math.round(s * 100);
      total += s * (weights[q.id] || 0);
    });
    var monthQ = questions.filter(function (q) { return q.match === "month"; })[0];
    var available = !monthQ || parts[monthQ.id] >= 50;
    return { total: Math.round(total * 100), parts: parts, available: available };
  }

  function rank(catalog, answers, questions, weights) {
    return catalog.map(function (it) {
      var sc = scoreItem(it, answers, questions, weights);
      return { item: it, total: sc.total, parts: sc.parts, available: sc.available };
    }).sort(function (a, b) { return b.total - a.total || (b.available - a.available); });
  }

  /* ---------- Styles (Shadow DOM, isolés) ---------- */
  function styles(brand) {
    var color = brand.color || "#5f6c50", accent = brand.accent || "#c9774f";
    return "\
:host{all:initial}*{box-sizing:border-box}\
.nq{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif;color:#2c2a26;line-height:1.55}\
.nq h2,.nq h3,.logo{font-family:Georgia,'Times New Roman',serif;font-weight:600;letter-spacing:-.01em;margin:0}\
.card{background:#fffdf9;border:1px solid #e3dac9;border-radius:18px;box-shadow:0 10px 40px rgba(50,40,25,.10);padding:30px 28px;max-width:640px;margin:0 auto}\
.brand{display:flex;align-items:center;gap:9px;justify-content:center;margin-bottom:4px}\
.logo{font-size:22px;letter-spacing:.12em;color:"+color+";text-transform:uppercase}\
.brand .dot{width:6px;height:6px;border-radius:50%;background:"+accent+";display:inline-block;margin-bottom:12px}\
.tagline{text-align:center;color:#6f6a61;font-size:13.5px;margin:0 0 18px}\
.progress{display:flex;gap:6px;margin-bottom:24px}\
.seg{flex:1;height:5px;border-radius:99px;background:#e3dac9;overflow:hidden}\
.seg span{display:block;height:100%;width:0;background:"+color+";transition:width .4s}\
.seg.done span{width:100%}\
.eyebrow{font-size:12px;letter-spacing:.12em;text-transform:uppercase;color:"+accent+";margin:0 0 6px}\
.q{font-size:23px;margin:0 0 4px}\
.help{color:#6f6a61;font-size:14px;margin:0 0 20px}\
.opts{display:grid;gap:11px}.opts.two{grid-template-columns:1fr 1fr}\
.opt{display:flex;align-items:center;gap:13px;text-align:left;background:#fff;border:1.5px solid #e3dac9;border-radius:14px;padding:14px 15px;cursor:pointer;transition:.18s;font-size:15px;color:#2c2a26;width:100%;font-family:inherit}\
.opt:hover{border-color:"+color+";transform:translateY(-1px);box-shadow:0 6px 18px rgba(90,100,70,.10)}\
.opt.sel{border-color:"+color+";background:#f3f6ee;box-shadow:0 0 0 3px rgba(124,138,107,.18)}\
.opt .ico{font-size:21px;width:28px;text-align:center;flex:none}\
.opt .txt{display:flex;flex-direction:column}.opt .txt b{font-weight:600}.opt .txt small{color:#6f6a61;font-size:12.5px}\
.opt .check{margin-left:auto;width:20px;height:20px;border-radius:50%;border:1.5px solid #e3dac9;flex:none;display:flex;align-items:center;justify-content:center;color:#fff;font-size:12px}\
.opt.sel .check{background:"+color+";border-color:"+color+"}\
.tinput{width:100%;border:1.5px solid #e3dac9;border-radius:14px;padding:14px 15px;font-size:16px;font-family:inherit;color:#2c2a26;background:#fff}\
.tinput:focus{outline:none;border-color:"+color+";box-shadow:0 0 0 3px rgba(124,138,107,.18)}\
.counter{text-align:right;font-size:12px;color:#9a948a;margin:6px 2px 0}\
.hint{font-size:12.5px;color:#6f6a61;margin:13px 0 0}\
.nav{display:flex;justify-content:space-between;align-items:center;margin-top:24px}\
.btn{border:none;border-radius:12px;padding:13px 24px;font-size:15px;font-weight:600;cursor:pointer;transition:.18s;font-family:inherit}\
.btn-primary{background:"+color+";color:#fff}.btn-primary:disabled{opacity:.4;cursor:not-allowed}\
.btn-ghost{background:transparent;color:#6f6a61;padding-left:4px}\
.analyze{text-align:center;padding:26px 8px}\
.spinner{width:60px;height:60px;margin:6px auto 20px;position:relative}\
.spinner div{position:absolute;inset:0;border:3px solid transparent;border-top-color:"+color+";border-radius:50%;animation:nqspin 1s linear infinite}\
.spinner div:nth-child(2){inset:9px;border-top-color:"+accent+";animation-duration:1.4s;animation-direction:reverse}\
@keyframes nqspin{to{transform:rotate(360deg)}}\
.alog{max-width:360px;margin:0 auto;text-align:left}\
.alog .l{display:flex;gap:10px;align-items:center;color:#6f6a61;font-size:14px;padding:6px 0;opacity:0;transform:translateX(-6px);transition:.35s}\
.alog .l.on{opacity:1;transform:none;color:#2c2a26}.alog .l .tick{color:"+color+";font-weight:700}\
.res-head{text-align:center;margin-bottom:20px}.res-head h2{font-size:25px;margin:6px 0 0}\
.match{border:1px solid #e3dac9;border-radius:16px;overflow:hidden;background:#fff}\
.photo{height:170px;background-size:cover;background-position:center;position:relative;background-color:#efe7da}\
.scorebadge{position:absolute;right:14px;top:14px;background:rgba(255,255,255,.94);border-radius:14px;padding:8px 12px;text-align:center;box-shadow:0 4px 14px rgba(0,0,0,.15)}\
.scorebadge b{display:block;font-family:Georgia,serif;font-size:23px;color:"+color+";line-height:1}\
.scorebadge small{font-size:10px;letter-spacing:.05em;text-transform:uppercase;color:#6f6a61}\
.mbody{padding:20px 22px 24px}\
.tagrow{display:flex;flex-wrap:wrap;gap:6px;margin-bottom:10px}\
.tag{font-size:11.5px;background:#f3f6ee;color:"+color+";border:1px solid #e0e8d4;padding:3px 9px;border-radius:99px}\
.tag.terra{background:#faece3;color:"+accent+";border-color:#f0d6c5}\
.match h3{font-size:20px;margin:2px 0 6px}\
.meta{display:flex;flex-wrap:wrap;gap:12px;color:#6f6a61;font-size:13.5px;margin:8px 0 12px}.meta span{display:flex;gap:5px;align-items:center}\
.price{font-family:Georgia,serif;font-size:18px}\
.perso{display:flex;align-items:center;gap:8px;background:#faf0e9;border:1px dashed "+accent+";border-radius:10px;padding:9px 12px;margin:12px 0;font-size:13.5px;color:#7a4a30}\
.perso b{font-weight:600}\
.why{background:#faf7f0;border:1px solid #e3dac9;border-radius:12px;padding:14px 16px;margin:14px 0}\
.why h4{margin:0 0 10px;font-size:13px;letter-spacing:.05em;text-transform:uppercase;color:#6f6a61;font-weight:700}\
.why.acc{padding:0;overflow:hidden}\
.acc-h{width:100%;display:flex;align-items:center;justify-content:space-between;gap:10px;background:none;border:none;font-family:inherit;font-size:12.5px;letter-spacing:.04em;text-transform:uppercase;color:#6f6a61;font-weight:700;padding:14px 16px;cursor:pointer;text-align:left}\
.acc-h:hover{color:"+color+"}\
.acc-c{padding:0 16px 16px}\
.chev{width:8px;height:8px;border-right:2px solid "+color+";border-bottom:2px solid "+color+";transform:rotate(45deg);transition:.2s;flex:none}\
.why.open .chev{transform:rotate(-135deg);margin-top:4px}\
.crit{display:flex;align-items:center;gap:10px;margin:7px 0;font-size:13.5px}\
.crit .lab{width:110px;color:#6f6a61;font-size:12.5px}\
.crit .bar{flex:1;height:7px;background:#e3dac9;border-radius:99px;overflow:hidden}\
.crit .bar i{display:block;height:100%;background:"+color+";border-radius:99px}\
.crit .pct{width:34px;text-align:right;font-weight:600;font-size:12.5px}\
.cta{margin-top:16px}\
.cta a{display:block;text-align:center;text-decoration:none;padding:14px;border-radius:12px;font-weight:600;font-size:15px;background:"+accent+";color:#fff}\
.alts{margin-top:24px}.alts h4{font-size:13px;letter-spacing:.05em;text-transform:uppercase;color:#6f6a61;font-weight:700;margin:0 0 12px}\
.altcard{display:flex;gap:14px;align-items:center;border:1px solid #e3dac9;border-radius:12px;padding:11px;margin-bottom:10px;text-decoration:none;color:#2c2a26;transition:.16s;background:#fff}\
.altcard:hover{border-color:"+color+";transform:translateX(2px)}\
.altcard .thumb{width:58px;height:58px;border-radius:10px;background-size:cover;background-position:center;flex:none;background-color:#efe7da}\
.altcard .info{flex:1}.altcard .info b{font-size:14px;font-weight:600;display:block}.altcard .info small{color:#6f6a61;font-size:12.5px}\
.altcard .sc{font-family:Georgia,serif;color:"+color+";font-size:18px;flex:none}\
.cheer{text-align:center;color:"+accent+";font-family:Georgia,serif;font-style:italic;font-size:15.5px;margin:22px 10px 2px;line-height:1.4}\
.restart{display:block;margin:14px auto 0}\
.byline{text-align:center;color:#9a948a;font-size:11px;margin-top:18px}\
.launch{position:fixed;right:22px;bottom:22px;left:auto;z-index:2147483646;background:"+color+";color:#fff;border:none;border-radius:50px;padding:14px 20px;font-size:15px;font-weight:600;cursor:pointer;box-shadow:0 8px 24px rgba(0,0,0,.22);font-family:inherit;max-width:calc(100vw - 32px);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}\
.launch:hover{filter:brightness(1.05)}\
.launch.left{left:22px;right:auto}\
.launch .lbl-short{display:none}\
.overlay{position:fixed;inset:0;z-index:2147483647;background:rgba(40,35,25,.55);display:flex;align-items:flex-start;justify-content:center;padding:34px 16px;overflow:auto;-webkit-overflow-scrolling:touch}\
.overlay .card{position:relative;margin:auto}\
.close{position:absolute;right:-10px;top:-10px;width:34px;height:34px;border-radius:50%;border:none;background:#fff;box-shadow:0 4px 12px rgba(0,0,0,.2);font-size:18px;cursor:pointer;color:#6f6a61;z-index:2}\
@media(max-width:560px){.opts.two{grid-template-columns:1fr}.card{padding:24px 18px}.q{font-size:20px}\
.launch{bottom:14px;right:14px;padding:12px 16px;font-size:13.5px}\
.launch.left{left:14px;right:auto}\
.overlay{padding:14px 10px;align-items:stretch}\
.overlay .card{width:100%;max-width:560px}\
.close{right:6px;top:6px}}\
@media(max-width:380px){.launch .lbl-long{display:none}.launch .lbl-short{display:inline}}\
";
  }

  /* ---------- Widget ---------- */
  function Widget(root, cfg) {
    this.root = root; this.cfg = cfg; this.Q = cfg.questions; this.step = 0; this.answers = {};
    var self = this;
    this.Q.forEach(function (q) { self.answers[q.id] = (q.type === "multi") ? [] : null; });
    this.render();
  }
  Widget.prototype.visible = function () {
    var self = this;
    return this.Q.filter(function (q) {
      if (!q.showIf) return true;
      var k = Object.keys(q.showIf)[0];
      return self.answers[k] === q.showIf[k];
    });
  };
  Widget.prototype.url = function (it) { return it.url || ((this.cfg.brand.productBaseUrl || "") + it.id); };
  Widget.prototype.shopifyImg = function (handle) {
    var base = this.cfg.brand && this.cfg.brand.productBaseUrl;
    if (!base) return Promise.reject();
    return fetch(base + encodeURI(handle) + ".js", { credentials: "omit" })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (p) {
        var img = p.featured_image || (p.images && p.images[0]);
        if (!img) throw 0;
        if (img.indexOf("//") === 0) img = "https:" + img;
        return img + (img.indexOf("?") >= 0 ? "&" : "?") + "width=800";
      });
  };
  Widget.prototype.upgradeImages = function (best, alts) {
    var self = this;
    if (!this.cfg.brand || this.cfg.brand.shopifyImages === false) return;
    var set = function (el, src) { if (el) el.style.backgroundImage = "url('" + src + "')"; };
    this.shopifyImg(best.item.id).then(function (s) { set(self.root.querySelector(".photo"), s); }).catch(function () {});
    var thumbs = this.root.querySelectorAll(".altcard .thumb");
    alts.forEach(function (a, i) { self.shopifyImg(a.item.id).then(function (s) { set(thumbs[i], s); }).catch(function () {}); });
  };
  Widget.prototype.fmt = function (p) { if (p == null) return ""; try { return Number(p).toLocaleString("fr-FR") + " €"; } catch (e) { return p + " €"; } };
  Widget.prototype.canNext = function (Q) { if (Q.type === "multi") return this.answers[Q.id].length > 0; if (Q.type === "text") return true; return this.answers[Q.id] !== null; };

  Widget.prototype.render = function () {
    var V = this.visible();
    if (this.step > V.length - 1) this.step = V.length - 1;
    if (this.step < V.length) this.renderQuestion(V);
  };
  Widget.prototype.progress = function (V, active) {
    var s = ""; for (var i = 0; i < V.length; i++) s += '<div class="seg ' + (i < active ? "done" : "") + '"><span style="' + (i < active ? "width:100%" : "") + '"></span></div>';
    return '<div class="progress">' + s + "</div>";
  };
  Widget.prototype.renderQuestion = function (V) {
    var self = this, Q = V[this.step], multi = Q.type === "multi", text = Q.type === "text", cur = this.answers[Q.id];
    var body;
    if (text) {
      var max = Q.maxlength || 40, val = cur || "";
      body = '<input class="tinput" id="nqtext" type="text" maxlength="' + max + '" placeholder="' + (Q.placeholder || "") + '" value="' + String(val).replace(/"/g, "&quot;") + '">' +
        '<div class="counter"><span id="nqc">' + val.length + "</span>/" + max + "</div>";
    } else {
      body = '<div class="opts ' + (Q.opts.length > 5 ? "two" : "") + '">' + Q.opts.map(function (o) {
        var sel = multi ? cur.indexOf(o.v) >= 0 : cur === o.v;
        return '<button class="opt ' + (sel ? "sel" : "") + '" data-v=\'' + JSON.stringify(o.v) + '\'>' +
          '<span class="ico">' + (o.ico || "") + '</span><span class="txt"><b>' + o.t + "</b>" + (o.s ? "<small>" + o.s + "</small>" : "") + "</span>" +
          '<span class="check">' + (sel ? "✓" : "") + "</span></button>";
      }).join("") + "</div>" + (multi ? '<p class="hint">Astuce : sélectionnez plusieurs choix pour affiner.</p>' : "");
    }

    this.root.innerHTML =
      '<div class="brand"><span class="logo">' + this.cfg.brand.name + '</span><span class="dot"></span></div>' +
      '<p class="tagline">' + (this.cfg.brand.tagline || "") + "</p>" +
      this.progress(V, this.step) +
      '<p class="eyebrow">Question ' + (this.step + 1) + " sur " + V.length + "</p>" +
      '<h2 class="q">' + Q.q + "</h2>" + '<p class="help">' + (Q.help || "") + "</p>" + body +
      '<div class="nav"><button class="btn btn-ghost" data-act="back" ' + (this.step === 0 ? 'style="visibility:hidden"' : "") + ">← Retour</button>" +
      '<button class="btn btn-primary" data-act="next" ' + (this.canNext(Q) ? "" : "disabled") + ">" +
      (this.step === V.length - 1 ? "Voir mon résultat ✦" : "Continuer →") + "</button></div>";

    if (text) {
      var inp = this.root.querySelector("#nqtext"), c = this.root.querySelector("#nqc");
      inp.oninput = function () { self.answers[Q.id] = inp.value; if (c) c.textContent = inp.value.length; };
      setTimeout(function () { inp.focus(); }, 30);
    } else {
      this.root.querySelectorAll(".opt").forEach(function (btn) {
        btn.onclick = function () {
          var v = JSON.parse(btn.getAttribute("data-v"));
          if (multi) { var i = self.answers[Q.id].indexOf(v); if (i >= 0) self.answers[Q.id].splice(i, 1); else self.answers[Q.id].push(v); }
          else { self.answers[Q.id] = v; }
          self.render();
        };
      });
    }
    var nb = this.root.querySelector('[data-act="next"]');
    if (nb) nb.onclick = function () { var VV = self.visible(); if (self.step >= VV.length - 1) self.analyze(); else { self.step++; self.render(); } };
    var bk = this.root.querySelector('[data-act="back"]');
    if (bk) bk.onclick = function () { self.step--; self.render(); };
  };

  Widget.prototype.analyze = function () {
    var self = this;
    var lines = [
      "Lecture de vos réponses…",
      "Filtrage des produits actifs du catalogue…",
      "Croisement de vos critères × catalogue…",
      "Calcul du score d'affinité pour " + this.cfg.catalog.length + " produits…",
      "Sélection de vos meilleures correspondances ✦"
    ];
    this.root.innerHTML = '<div class="analyze"><div class="spinner"><div></div><div></div></div><h2>Analyse en cours…</h2><div class="alog">' +
      lines.map(function (l, i) { return '<div class="l" id="nql' + i + '"><span class="tick">✓</span><span>' + l + "</span></div>"; }).join("") + "</div></div>";
    lines.forEach(function (_, i) { setTimeout(function () { var el = self.root.querySelector("#nql" + i); if (el) el.classList.add("on"); }, 320 + i * 400); });
    setTimeout(function () { self.result(); }, 320 + lines.length * 400 + 450);
  };

  Widget.prototype.scoredQuestions = function () { return this.Q.filter(function (q) { return q.type !== "text" && q.match !== "none"; }); };
  Widget.prototype.optLabel = function (q, v) { var o = (q.opts || []).filter(function (x) { return x.v === v; })[0]; return o ? o.t : v; };

  Widget.prototype.explain = function (best) {
    var self = this;
    var strong = this.scoredQuestions().filter(function (q) { return best.parts[q.id] >= 80; });
    var labels = strong.map(function (q) { return (q.shortLabel || q.q).toLowerCase(); });
    var s = "Ce produit coche " + strong.length + " de vos critères clés";
    if (labels.length) s += " : " + labels.join(", ");
    return s + ". L'analyse a comparé vos réponses à l'ensemble du catalogue pour ne garder que les pièces les plus pertinentes.";
  };

  Widget.prototype.personalizationText = function () {
    var self = this, txt = "";
    this.Q.forEach(function (q) { if (q.type === "text" && self.answers[q.id]) txt = self.answers[q.id]; });
    return txt;
  };

  Widget.prototype.result = function () {
    var self = this, cfg = this.cfg, ui = cfg.ui || {};
    var r = rank(cfg.catalog, this.answers, this.Q, cfg.weights || {});
    var best = r[0], t = best.item, url = this.url(t);
    var maxAlts = ui.maxAlts != null ? ui.maxAlts : 3;
    var thr = ui.altThreshold != null ? ui.altThreshold : 0;
    var alts = r.slice(1).filter(function (a) { return a.total >= thr; }).slice(0, maxAlts);

    var crit = this.scoredQuestions().map(function (q) {
      return '<div class="crit"><span class="lab">' + (q.shortLabel || q.q) + '</span><span class="bar"><i style="width:' + best.parts[q.id] + '%"></i></span><span class="pct">' + best.parts[q.id] + "%</span></div>";
    }).join("");

    var chips = (t.chips || []).slice(0, 4).map(function (c) { return '<span class="tag">' + c + "</span>"; }).join("") +
      (t.bestseller ? '<span class="tag terra">★ Best-seller</span>' : "");

    var persoTxt = this.personalizationText();
    var persoHtml = persoTxt ? '<div class="perso">✍️ Personnalisation : <b>« ' + persoTxt.replace(/</g, "&lt;") + ' »</b></div>' : "";

    var altsHtml = alts.map(function (a) {
      return '<a class="altcard" href="' + self.url(a.item) + '" target="_blank" rel="noopener">' +
        '<span class="thumb" style="background-image:url(\'' + (a.item.img || "") + '\')"></span>' +
        '<span class="info"><b>' + a.item.title + "</b><small>" + (a.item.dest || a.item.subtitle || "") + (a.item.price != null ? " · dès " + self.fmt(a.item.price) : "") + "</small></span>" +
        '<span class="sc">' + a.total + "%</span></a>";
    }).join("");

    var metaBits = [];
    if (t.subtitle || t.dest) metaBits.push("<span>📍 " + (t.subtitle || t.dest) + "</span>");
    if (t.days) metaBits.push("<span>⏱️ " + t.days + " jours</span>");
    if (t.dates) metaBits.push("<span>🗓️ " + t.dates.join(" · ") + "</span>");

    this.root.innerHTML =
      '<div class="res-head"><span class="eyebrow">' + (ui.eyebrow || "Votre correspondance") + '</span><h2>' + (ui.resultTitle || "Le produit fait pour vous") + "</h2></div>" +
      '<div class="match"><div class="photo" style="background-image:url(\'' + (t.img || "") + '\')"><div class="scorebadge"><b>' + best.total + '%</b><small>d\'affinité</small></div></div>' +
      '<div class="mbody">' + (chips ? '<div class="tagrow">' + chips + "</div>" : "") + "<h3>" + t.title + "</h3>" +
      (metaBits.length ? '<div class="meta">' + metaBits.join("") + "</div>" : "") +
      (t.price != null ? '<div class="price">À partir de ' + this.fmt(t.price) + "</div>" : "") +
      persoHtml +
      '<div class="why acc"><button type="button" class="acc-h" data-acc>Pourquoi ce produit vous correspond<span class="chev"></span></button>' +
      '<div class="acc-c" hidden>' + crit +
      '<p style="margin:12px 0 0;font-size:13.5px;color:#6f6a61">' + this.explain(best) + "</p></div></div>" +
      '<div class="cta"><a href="' + url + '" target="_blank" rel="noopener">' + (ui.ctaLabel || "Découvrir ce produit →") + "</a></div></div></div>" +
      (alts.length ? '<div class="alts"><h4>' + (ui.altsTitle || "Nos autres suggestions pour vous") + "</h4>" + altsHtml + "</div>" : "") +
      (ui.resultFooter ? '<p class="cheer">' + ui.resultFooter + "</p>" : "") +
      '<button class="btn btn-ghost restart" data-act="restart">↺ Refaire le quiz</button>' +
      '<p class="byline">Recommandation automatique · ' + cfg.brand.name + "</p>";

    var accH = this.root.querySelector("[data-acc]");
    if (accH) accH.onclick = function () {
      var c = self.root.querySelector(".acc-c"); var open = c.hasAttribute("hidden");
      if (open) c.removeAttribute("hidden"); else c.setAttribute("hidden", "");
      accH.parentNode.classList.toggle("open", open);
    };

    this.root.querySelector('[data-act="restart"]').onclick = function () {
      self.step = 0; self.Q.forEach(function (q) { self.answers[q.id] = q.type === "multi" ? [] : null; }); self.render();
    };

    this.upgradeImages(best, alts); // remplace les images par les vraies photos produit Shopify
  };

  /* ---------- Validation de la config ---------- */
  function configError(cfg) {
    if (!cfg || typeof cfg !== "object") return "Configuration absente ou illisible.";
    if (!cfg.questions) return "La config ne contient pas de « questions ». Avez-vous bien remplacé le commentaire « /* … */ » par tout le contenu de greffieres-config.json ?";
    if (!Array.isArray(cfg.questions) || !cfg.questions.length) return "La liste « questions » est vide.";
    if (!Array.isArray(cfg.catalog) || !cfg.catalog.length) return "Le « catalog » est vide.";
    return null;
  }
  function errorHtml(msg) {
    return '<div style="font-family:-apple-system,Arial,sans-serif;color:#9a3b2b;font-size:14px;line-height:1.5">' +
      '<b style="display:block;font-size:15px;margin-bottom:6px">⚠️ Quiz non chargé</b>' + msg +
      '<br><span style="color:#9a948a;font-size:12.5px">Détail technique dans la console du navigateur (touche F12 → Console).</span></div>';
  }

  /* ---------- Bootstrap : Shadow DOM + montage ---------- */
  function buildShell(cfg) {
    var host = document.createElement("div"); host.setAttribute("data-quiz-embed", "");
    var shadow = host.attachShadow ? host.attachShadow({ mode: "open" }) : host;
    var st = document.createElement("style"); st.textContent = styles((cfg && cfg.brand) || {}); shadow.appendChild(st);
    var wrap = document.createElement("div"); wrap.className = "nq"; shadow.appendChild(wrap);
    return { host: host, wrap: wrap };
  }
  function inlineHost() { return TARGET_SEL ? document.querySelector(TARGET_SEL) : null; }

  function mount(cfg) {
    var err = configError(cfg);
    var shell = buildShell(cfg), wrap = shell.wrap;

    if (MODE === "inline") {
      (inlineHost() || document.body).appendChild(shell.host);
      var card = document.createElement("div"); card.className = "card"; wrap.appendChild(card);
      if (err) { card.innerHTML = errorHtml(err); console.error("[QuizEmbed]", err); return; }
      try { new Widget(card, cfg); }
      catch (e) { card.innerHTML = errorHtml("Erreur d'exécution : " + e.message); console.error("[QuizEmbed]", e); }
    } else {
      if (err) { console.error("[QuizEmbed]", err); return; }
      document.body.appendChild(shell.host);
      var pos = POSITION || (cfg.ui && cfg.ui.launchPosition) || "right";
      var labelFull = (cfg.ui && cfg.ui.launchLabel) || "✦ Trouver le produit idéal";
      var labelShort = (cfg.ui && cfg.ui.launchLabelShort) || "✦ Quiz";
      var btn = document.createElement("button"); btn.className = "launch" + (pos === "left" ? " left" : "");
      btn.setAttribute("aria-label", labelFull);
      btn.innerHTML = '<span class="lbl-long">' + labelFull + '</span><span class="lbl-short">' + labelShort + "</span>";
      wrap.appendChild(btn);
      btn.onclick = function () {
        if (wrap.querySelector(".overlay")) return;
        var ov = document.createElement("div"); ov.className = "overlay";
        var card = document.createElement("div"); card.className = "card";
        var close = document.createElement("button"); close.className = "close"; close.innerHTML = "✕";
        close.onclick = function () { ov.remove(); };
        ov.onclick = function (e) { if (e.target === ov) ov.remove(); };
        card.appendChild(close); ov.appendChild(card); wrap.appendChild(ov);
        try { new Widget(card, cfg); } catch (e) { card.innerHTML = errorHtml("Erreur d'exécution : " + e.message); console.error("[QuizEmbed]", e); }
      };
    }
  }

  /* ---------- Synchro live du catalogue depuis Shopify ----------
     Lit /collections/{collection}/products.json (ou /products.json) sur le même
     domaine, et construit le catalogue à partir des produits PUBLIÉS et EN STOCK.
     Les critères de matching proviennent de tags posés sur chaque produit, ex. :
        forme:rond | type:plat | taille:grand | taille:tres-grand | repas:four | perso:oui
     Un produit sans tag « type: » ni « forme: » est ignoré (non destiné au quiz). */
  function shopifyOrigin(cfg, src) {
    if (src.base) return src.base.replace(/\/$/, "");
    try { return new URL(cfg.brand.productBaseUrl).origin; } catch (e) { return ""; }
  }
  function cap(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }

  function buildShopifyCatalog(cfg) {
    var src = cfg.catalogSource;
    var origin = shopifyOrigin(cfg, src);
    var coll = src.collection || null;
    var path = origin + (coll ? "/collections/" + coll + "/products.json" : "/products.json");
    var pre = src.tagPrefixes || { forme: "forme:", type: "type:", taille: "taille:", repas: "repas:", perso: "perso:" };
    var onlyAvail = src.onlyAvailable !== false;
    var exclude = src.excludeTag || null;
    var acc = [];

    function vals(tags, prefix) {
      var p = prefix.toLowerCase();
      return tags.filter(function (t) { return t.toLowerCase().indexOf(p) === 0; })
        .map(function (t) { return t.slice(prefix.length).trim().toLowerCase().replace(/\s+/g, "-"); })
        .filter(Boolean);
    }
    function mapProduct(p) {
      var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || "").split(",");
      tags = tags.map(function (t) { return String(t).trim(); }).filter(Boolean);
      if (exclude && tags.indexOf(exclude) >= 0) return null;
      var forme = vals(tags, pre.forme)[0] || "";
      var type = vals(tags, pre.type)[0] || "";
      if (!forme && !type) return null; // pas destiné au quiz
      var taille = vals(tags, pre.taille);
      var repas = vals(tags, pre.repas);
      var persoVals = vals(tags, pre.perso);
      var perso = persoVals.indexOf("oui") >= 0 || persoVals.indexOf("true") >= 0;
      var variants = p.variants || [];
      var available = variants.some(function (v) { return v.available; });
      if (onlyAvail && !available) return null;
      var prices = variants.map(function (v) { return parseFloat(v.price); }).filter(function (x) { return !isNaN(x); });
      var price = prices.length ? Math.min.apply(null, prices) : null;
      var img = (p.images && p.images[0] && p.images[0].src) || "";
      if (img.indexOf("//") === 0) img = "https:" + img;
      var chips = [];
      if (forme) chips.push(cap(forme));
      if (p.product_type) chips.push(p.product_type);
      return {
        id: p.handle, title: p.title, subtitle: p.product_type || "", price: price,
        chips: chips, img: img,
        tags: { forme: forme, type: type, taille: taille, repas: repas, perso: perso }
      };
    }
    function page(n) {
      return fetch(path + "?limit=250&page=" + n, { credentials: "omit" })
        .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status + " sur " + path); return r.json(); })
        .then(function (d) {
          var ps = (d && d.products) || [];
          acc = acc.concat(ps);
          if (ps.length === 250 && n < 12) return page(n + 1);
          return acc;
        });
    }
    return page(1).then(function (products) {
      return products.map(mapProduct).filter(Boolean);
    });
  }

  /* ---------- Variantes (parcours interchangeables : inspiration, cadeau…) ---------- */
  function resolveVariant(cfg) {
    if (!cfg.variants) return cfg;
    var keys = Object.keys(cfg.variants);
    var name = VARIANT || cfg.activeVariant || keys[0];
    var v = cfg.variants[name] || cfg.variants[keys[0]];
    if (!cfg.variants[name]) console.warn("[QuizEmbed] variante inconnue, repli sur", keys[0]);
    if (v.questions) cfg.questions = v.questions;
    if (v.weights) cfg.weights = v.weights;
    cfg.ui = Object.assign({}, cfg.ui || {}, v.ui || {});
    cfg._variant = name;
    return cfg;
  }

  function boot() {
    loadConfig().then(function (cfg) {
      resolveVariant(cfg);
      var src = cfg.catalogSource;
      if (!src || src.type !== "shopify") { mount(cfg); return; }
      // Synchro live, avec filet de sécurité : on monte au plus tard après 4 s.
      var mounted = false;
      var go = function () { if (!mounted) { mounted = true; mount(cfg); } };
      buildShopifyCatalog(cfg).then(function (items) {
        if (items && items.length) { cfg.catalog = items; console.info("[QuizEmbed] catalogue live :", items.length, "produits"); }
        else console.warn("[QuizEmbed] synchro live : 0 produit taggé, catalogue statique conservé.");
      }).catch(function (e) {
        console.warn("[QuizEmbed] synchro live échouée, catalogue statique conservé :", e.message);
      }).then(go);
      setTimeout(go, 4000);
    }).catch(function (e) {
      console.error("[QuizEmbed]", e.message);
      if (MODE === "inline") {
        var shell = buildShell(null); (inlineHost() || document.body).appendChild(shell.host);
        var card = document.createElement("div"); card.className = "card"; shell.wrap.appendChild(card);
        card.innerHTML = errorHtml("Impossible de charger la configuration : " + e.message);
      }
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();